import type { KeyPerson } from "@/mocks/events";

const personIcon = [
  "ri-building-line",
  "ri-store-line",
  "ri-tools-line",
  "ri-user-star-line",
];

export default function KeyPeople({ people }: { people: KeyPerson[] }) {
  return (
    <section id="sec-people" className="scroll-mt-20">
      <h2 className="flex items-center gap-2.5 font-heading text-xl font-black text-foreground-950 md:text-2xl">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50">
          <i className="ri-group-line" aria-hidden="true"></i>
        </span>
        关键人物与角色
      </h2>
      <p className="mt-2 text-sm text-foreground-600">
        角色化呈现事件中的主要参与方，说明各自立场来源，不做人格化定罪。
      </p>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {people.map((p, i) => (
          <div
            key={p.name}
            className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-200"
          >
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className={`${personIcon[i % personIcon.length]} text-lg`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="text-sm font-bold text-foreground-900">{p.name}</h3>
                <span className="text-xs text-accent-700">{p.role}</span>
              </div>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}